module.exports = __webpack_public_path__ + "img/pdf_icon.9a857520.png";